export default __webpack_public_path__ + "static/media/velocity-use-case-img2.d6a76387.png";